import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18f3164f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, [
  /*#__PURE__*/_createElementVNode("span", null, "选择工作结束时间")
], -1))
const _hoisted_2 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_picker = _resolveComponent("van-picker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_openBlock(), _createBlock(_component_van_picker, {
      ref: "picker",
      "show-toolbar": false,
      "default-index": _ctx.defaultIndex,
      onChange: _ctx.onChange,
      loading: _ctx.loading,
      key: _ctx.account_type_value,
      columns: _ctx.columns
    }, null, 8, ["default-index", "onChange", "loading", "columns"])),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerComfirm && _ctx.triggerComfirm(...args))),
        class: "btn btn_com"
      }, "确定")
    ])
  ]))
}